
import Backend from "../Backend"

class ApplicationsData {


  static fetchApplications = function() {
    return Backend.getData('/api/comp/openapplications');
  }

  static fetchDisc = async function() {
    return Backend.getData('/api/TAB_DISZI');
  }

  static fetchCourseInfo = async function(courseID) {
    return Backend.getData('/api/TAB_KURSSTAMMDATEN/' + courseID)
  }


  static fetchDatesforCourse = async function(dateLink)  {
    return Backend.getData(dateLink + '?orderby=KD_Anfangstag')
  }



  // this.fetchDataForStateChange = function(courseID) {
  //
  //   // object for storing course-info and as well as dates
  //   data = {}
  //
  //   // construct new promise encapsulating both api-calls
  //   // and reject promise as needed
  //   return $q((resolve, reject) => {
  //
  //     // fetch information about course
  //     service.fetchCourseInfo(courseID)
  //       .then(courseInfo => {
  //
  //
  //         // no information about course ?
  //         if (courseInfo.length == 0) {
  //
  //           // reject promise
  //           reject('Kursdaten konnten nicht abgerufen werden!')
  //         } else {
  //
  //           // attach course-info for returning
  //           data.course = courseInfo[0];
  //
  //           // get course-dates
  //           service.fetchDatesforCourse(data.course._links["Kurstermine dieses Stammkurses"].href)
  //             .then(dates => {
  //
  //               // return couse-info and dates
  //               data.dates = dates;
  //               resolve(data)
  //             }, rej => {
  //
  //               // reject if dates could not be loaded
  //               reject('Kurstermine konnten nicht abgerufen werden!')
  //             })
  //         }
  //
  //
  //       })
  //   })
  // }

  static saveStateChangeWithoutDate = async function(applicationID, newState) {
    return Backend.putData('/api/TAB_KURSANMELDUNG/' + applicationID, {
      KA_ID: applicationID,
      KA_Status: newState,
    })
  }


  static saveStateChangeWithDate = async function(employeeID, dateID, applicationID, newState) {
    return Backend.postData('/api/actions/kursanmeldung', {
      Mitarbeiter_ID: employeeID,
      Kurstermin_ID: dateID,
      Anmeldung_ID: applicationID,
      Status: newState
    })
  }

}

export default ApplicationsData;